import React from 'react';
import Dropdown from '../global/Dropdown';
import Button from '../global/Button';
export default function FiltersBar({
  filters,
  filterOptions,
  onSetFilter,
  onGetData,
  onReset,
  hasFilters,
}) {
  return (
    <div className="filters-bar">
      <div className="filters-row">
        {filterOptions.map((f) => {
          const dropdownOptions = f.options.map((s) => ({ value: s, label: s }));
          return (
            <div className="filter-select-wrap" key={f.key}>
              <Dropdown
                options={dropdownOptions}
                value={filters[f.key] ?? ''}
                onChange={(value) => onSetFilter(f.key, value)}
                placeholder={f.allLabel}
                ariaLabel={`${f.label} filter`}
                rootClassName="filter-dropdown-root"
              />
            </div>
          );
        })}
      </div>

      <div className="filters-actions">
        <Button className="getdata-btn" type="button" variant="secondary" onClick={onGetData}>
          Get Data
        </Button>
        <Button className="reset-btn" type="button" variant="primary" onClick={onReset}>
          Reset
        </Button>
      </div>
    </div>
  );
}

